const guides = [
  {
    id: 1,
    icon: 'ri-flashlight-line',
    title: 'Essential Gear',
    description: 'From tents to cooking equipment, discover the must-have items for a comfortable camping experience in Hudson Valley. Learn what to pack for different seasons and weather conditions.',
  },
  {
    id: 2,
    icon: 'ri-map-2-line',
    title: 'Trip Planning',
    description: 'Master the art of planning your perfect outdoor adventure. Get insider tips on booking campsites, choosing the best routes, and creating memorable itineraries for your family.',
  },
  {
    id: 3,
    icon: 'ri-truck-line',
    title: 'RV Basics',
    description: 'New to RVing? Learn everything from driving tips to hookup procedures. Understand maintenance schedules, fuel efficiency, and how to choose the right RV for your adventures.',
  },
];

const TipsGuides = () => {
  return (
    <section className="py-24 bg-[#F5F1E8]">
      <div className="max-w-7xl mx-auto px-6">
        <div className="mb-12">
          <p className="text-sm uppercase tracking-wider text-gray-500 mb-4">ESSENTIAL KNOWLEDGE</p>
          <h2 className="font-serif text-6xl font-extrabold text-gray-900 leading-tight">
            Everything You Need<br />
            to Know
          </h2>
        </div>

        <div className="grid grid-cols-3 gap-8">
          {guides.map((guide) => (
            <div
              key={guide.id}
              className="bg-gray-50 rounded-2xl p-12 hover:bg-white hover:shadow-lg transition-all duration-300"
            >
              <div className="w-16 h-16 flex items-center justify-center mb-8">
                <i className={`${guide.icon} text-6xl text-gray-900`}></i>
              </div>
              
              <h3 className="font-bold text-3xl text-gray-900 mb-6">
                {guide.title}
              </h3>
              
              <p className="text-gray-600 leading-relaxed">
                {guide.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default TipsGuides;